import React from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import styled from 'styled-components';

import { MenuItem } from '@mui/material';

import { PickerProps } from 'components/Grid/operators/types';

import { StyledSelect } from 'components/Input/styles';

import { useStore } from 'utils/hooks/store';

import { createFilterRegex } from 'utils/regex';
import { colors } from 'theme/colors';
import { ProductLicenseName, productLicensesFor } from 'core/constants';

export const StyledMenuItem = styled(MenuItem)`
  color: ${colors.legacy.grey[200]};
  font-size: 1.3rem;
  line-height: 2rem;
  p {
    margin: 0;
  }
`;

const ProductLicencesOperator: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => {
  const { session } = useStore();

  return (
    <StyledSelect
      {...props}
      value={item.value && (item.value as string).startsWith('-') ? (item.value as string).slice(1) : item.value}
      fullWidth
      onChange={(newValue) => applyValue({ ...item, value: newValue.target.value })}
    >
      {productLicensesFor({ hasEventsLicense: session.hasEventsLicense, hasRisksLicense: session.hasRisksLicense }).map(
        ({ key, label }) => (
          <StyledMenuItem key={key} value={key}>
            <p>{label}</p>
          </StyledMenuItem>
        )
      )}
    </StyledSelect>
  );
};

export default [
  {
    label: 'is',
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value) {
        return null;
      }
      const filterRegex = createFilterRegex(filterItem.value);
      return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
    },
    InputComponent: ProductLicencesOperator,
    InputComponentProps: { value: null },
    getValueAsString: (value: string) => ProductLicenseName[value],
  },
  {
    label: 'is not',
    value: 'is not',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value) {
        return null;
      }
      const filterRegex = createFilterRegex(filterItem.value);
      return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
    },
    InputComponent: ProductLicencesOperator,
    InputComponentProps: { value: null },
    getValueAsString: (value: string) => ProductLicenseName[value.slice(1)],
  },
] as unknown as GridFilterOperator[];
